import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Visibility = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Every Event on Guild is either{' '}
        <Paragraph size='$5' fontWeight='$7'>listed</Paragraph> or{' '}
        <Paragraph size='$5' fontWeight='$7'>unlisted</Paragraph>. This setting
        controls where the Event appears and who can discover it.
      </Paragraph>
      <DocScreenshot
        src='docs/events/event-page.png'
        alt='Event page showing the Listed badge next to the event title indicating the Event is publicly discoverable'
        caption='Listed Events display a badge on the Event page'
      />
    </Card>

    <Card gap='$4'>
      <DocSection id='visibility-types' title='Visibility Types'>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='globe' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Listed Events</Paragraph> — Fully
              public. They appear on your Guild's Events tab, in search results, and in
              the global Events listing. Anyone browsing Guild can discover a listed
              Event and RSVP or purchase tickets.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='lock-closed' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Unlisted Events</Paragraph> — Do not
              appear in any public listings or search results. They are only accessible
              via a direct link. This is useful for private gatherings, invite-only
              Events, or Events that are still being set up and not ready to be
              announced publicly.
            </Paragraph>
          </XStack>
        </YStack>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='changing-visibility' title='Changing Visibility'>
        <Paragraph size='$5'>
          You can toggle visibility at any time from{' '}
          <Link href='/docs/events/settings'>Event Settings</Link> under the
          General section. Changing an Event from unlisted to listed makes it
          immediately discoverable. Changing it back to unlisted removes it from
          public listings but does not affect existing attendees — anyone who has
          already RSVPed retains their spot.
        </Paragraph>
        <Paragraph size='$5'>
          The Event page displays a{' '}
          <Paragraph size='$5' fontWeight='$7'>Listed</Paragraph> badge next to the
          title so organizers can quickly confirm the current visibility setting. An
          unlisted Event shows no badge, reminding organizers that it is only
          reachable by sharing the link directly.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default Visibility
